import { __extends } from "tslib";
import { TextureBase } from './TextureBase';
/**
 *
 */
var TextureCube = /** @class */ (function (_super) {
    __extends(TextureCube, _super);
    function TextureCube() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextureCube.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return TextureCube.assetType;
        },
        enumerable: true,
        configurable: true
    });
    TextureCube.assetType = '[texture TextureCube]';
    return TextureCube;
}(TextureBase));
export { TextureCube };
